export * from './getLocaleData'
export * from './getAllLocalesData'